import React from 'react';
import ThreeDostVertical from "assets/img/svg/svgComponents/ThreeDotsVertical";
import APopover from '../../../../../../../views/pages/manage/common/a-popover';
import styles from "../../../styles.module.scss";
import { FULL_REFUND } from '../../../utils';
import { formattedPrice } from '../../../../../../../views/pages/manage/unAssigned/collectPayment/utils';


const FullRefundCta = ({
    setShowFullRefundItem,
    payableRefundInfo
}) => {

    const { totalRefundableAmount } = payableRefundInfo?.[FULL_REFUND] ?? {};

    return (
        <APopover
            buttonComponent={(openPopup) => <span className="cursor" onClick={openPopup}><ThreeDostVertical /></span>}
            menuComponent={(closePopup) =>
                <div className={styles['full-refund-cta'] + " cursor"} onClick={() => {setShowFullRefundItem(true); closePopup()}}>
                    <div className={styles['title']}>Issue full refund</div>
                    <div className={styles['amount-info']}>Refund full amount {formattedPrice(totalRefundableAmount)}</div>
                </div>
            }
        />
    );
}

export default FullRefundCta;